// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__7ZQoo","item":"Header_item__KsJuU","notification":"Header_notification__naz4h"};